module.exports = __webpack_public_path__ + "static/img/question-bg.a46f89c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/blockIcon/question-bg.png
// module id = LaTB
// module chunks = 96